import styled from 'styled-components';
import {
  FontSizes,
  LinkSmall,
} from '../../common/typography/typography.styles';

export const HintElement = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.8rem 1.6rem 1.6rem 1.6rem;
  align-items: center;

  @media (max-width: 650px) {
    padding-top: 0;
  }

  svg {
    flex-shrink: 0;
  }

  .hintText {
    font-size: ${FontSizes.normal};
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: 0.5px;
  }

  ${LinkSmall} {
    font-size: ${FontSizes.normal};
  }
`;
